import React from 'react';
import { Redirect, Route, BrowserRouter, Switch } from 'react-router-dom';
import { PATHS } from '../common/constants';
import Asset from '../pages/Asset';
import Catalog from '../pages/Catalog/Catalog';
import Contact from '../pages/Contact';
import Item from '../pages/Item';
import Properties from '../pages/Properties';
import Property from '../pages/Property';
import ServiceRequests from '../pages/ServiceRequests';
import ServiceRequest from '../pages/ServiceRequest';
import Settings from '../pages/Settings/Settings';
import Suite from '../pages/Suite';
import VideoChat from '../pages/VideoChat';
import ViewImage from '../pages/ViewImage';
import Dashboard from '../pages/HomeOwnerDashboard/Dashboard';
import EventAddingWithCalendly from '../pages/CalendlyIntegration/EventAdding';
import Announcements from '../pages/Announcements/Announcements';
import Announcementsview from '../pages/Announcements/Announcementsview';
import CommonArea from '../pages/CommonArea';
import Reporting from '../pages/Reporting/Reporting';
import KeyContacts from '../pages/KeyContacts';
import KeyContact from '../pages/KeyContact';
import Homeowneronboarding from '../pages/HomeOwnerDashboard/Homeowneronboarding';
import OnboardingDashboard from '../pages/HomeOwnerDashboard/HomeOwnerOnboardingContainer';
import ChangePassword from '../pages/ChangePassword';
import InboxContainer from '../pages/Inbox/InboxContainer';
import Request from '../pages/Request/Request';
import EmailTemplates from '../pages/EmailTemplates';
import { CalendarComponent } from 'src/pages/Calendar/CalendarComponent';
import Contacts from 'src/pages/Contacts/Contacts';

const AdminRoutes = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path={PATHS.CALENDAR} component={CalendarComponent} />
        <Route path={PATHS.SETTINGS} component={Settings} />
        <Route path={PATHS.ASSETS_VIEW} component={Asset} />
        <Route path={PATHS.CONTACTS_VIEW} component={Contact} />
        <Route path={PATHS.KEY_CONTACTS_VIEW} component={KeyContact} />
        <Route path={PATHS.CONTACTS_LIST} component={Contacts} />
        <Route path={PATHS.KEY_CONTACTS_LIST} component={KeyContacts} />
        <Route path={PATHS.PROPERTIES_VIEW} component={Property} />
        <Route path={PATHS.PROPERTIES_LIST} component={Properties} />
        <Route path={PATHS.ITEMS_LIST} component={Catalog} />
        <Route path={PATHS.ITEMS_VIEW} component={Item} />
        <Route path={PATHS.SERVICE_REQUESTS_VIEW} component={ServiceRequest} />
        <Route path={PATHS.SERVICE_REQUESTS_LIST} component={ServiceRequests} />
        <Route path={PATHS.SUITES_VIEW} component={Suite} />
        <Route path={PATHS.VIDEO_CHAT} component={VideoChat} />
        <Route path={PATHS.VIEW_IMAGE} component={ViewImage} />
        <Route path={PATHS.CHANGE_PASSWORD} component={ChangePassword} />
        <Route path={PATHS.DASHBOARD} component={Dashboard} />
        <Route
          path={PATHS.HOMEOWNER_ONBOARDING_DASHBOARD}
          component={OnboardingDashboard}
        />
        <Route path={PATHS.EVENT_ADDING} component={EventAddingWithCalendly} />
        <Route path={PATHS.ANNOUNCEMENTS} component={Announcements} />
        <Route path={PATHS.ANNOUNCEMENTS_VIWE} component={Announcementsview} />
        <Route path={PATHS.COMMON_AREA_VIEW} component={CommonArea} />
        <Route path={PATHS.REPORTING} component={Reporting} />
        <Route path={PATHS.INBOX} component={InboxContainer} />
        <Route path={PATHS.REQUEST} component={Request} />
        <Route
          path={PATHS.HOMEOWNER_ONBOARDING}
          component={Homeowneronboarding}
        />
        <Route path={PATHS.EMAIL_TEMPLATES} component={EmailTemplates} />
        <Route path="/">
          <Redirect to={PATHS.SERVICE_REQUESTS_LIST} />
        </Route>
      </Switch>
    </BrowserRouter>
  );
};

export default AdminRoutes;
